// extracted by mini-css-extract-plugin
export default {"tab_container":"styles_tab_container__H41I9","tab_item":"styles_tab_item__TdTDw","active":"styles_active__bMIx5"};